import {
	createComponentExtension,
	createPlugin,
} from '@backstage/core-plugin-api';

export const teamMetadataPlugin = createPlugin({
	id: 'team-metadata',
});

export const TeamMetadataCardGridItem = teamMetadataPlugin.provide(
	createComponentExtension({
		name: 'TeamMetadataCardGridItem',
		component: {
			lazy: () =>
				import('./components/TeamMetadataCard').then(
					m => m.TeamMetadataCardGridItem,
				),
		},
	}),
);
